import React, { useState } from 'react'
import { Accordion, Button, Table } from 'react-bootstrap'
import Spinner1 from '../common/spinners'
import { formattedDate } from '../../utils/utilities'
import moment from 'moment'

const DrugsAndPrescription = ({filteredData, loading, searchQuery}) => {

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 3

    //   const filteredData = data?.filter( (item) =>
    //       item?.patient?.hmo?.name?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
    //       item?.requestType?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
    //       item?.item?.vaccine?.name_of_vaccine?.toLowerCase()?.includes(searchQuery?.toLowerCase())        
    //   );


    const totalPages = Math.ceil(filteredData?.length / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData?.slice(indexOfFirstItem, indexOfLastItem);

    console.log(currentItems,'user bils')

  
    return (
        <>
            {
            loading ? (
                <div className="w-100 d-flex justify-content-center"><Spinner1 /></div>
            ) : 

            !loading && !filteredData?.length?
            <div className='data-table-empty'>
                <h6>No medication records found</h6>
                <p>Try a different search term to surface the prescription you need.</p>
            </div>
            :

            (
                <Accordion defaultActiveKey={0} className="d-grid gap-3">
                    {currentItems?.map((item, index) => {
                        return (
                            <Accordion.Item key={index} eventKey={index} className="border-0 rounded-4 overflow-hidden shadow-sm">
                                <Accordion.Header className='accordion-header table-responsive'>
                                    <table className='table table-agent mb-0' style={{ '--bs-table-bg': 'transparent', '--bs-table-color': 'transparent' }}>
                                        <tbody>
                                            <tr style={{ width: '100%' }}>
                                                <td>
                                                    <div className="d-flex align-items-center gap-2">
                                                        <div className="avatar border border-2 border-success text-info d-flex justify-content-center align-items-center"><i className="ri-arrow-right-up-line"></i></div>
                                                        <div>
                                                            <h6 className="mb-1">
                                                              {item?.admission ? ('Prescription from Admission'):'Prescription Consultation'}  
                                                            </h6>
                                                            <div className='d-flex'>
                                                                <h6 className="fs-sm text-primary">{formattedDate(item?.created_at)}</h6> 
                                                                |
                                                                 {/* <h6 className='fs-sm'>Adult female ward</h6> */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <label className="d-block text-secondary fs-sm mb-1">Cost</label>
                                                    <h6>
                                                        {item?.requests
                                                            ?.map((x) => Math.abs(x?.item?.transaction?.amount || 0)) // Convert to absolute values
                                                            ?.reduce((sum, amount) => sum + amount, 0).toLocaleString("en-NG", { style: "currency", currency: "NGN" }) // Sum up
                                                        }
                                                        </h6>

                                                </td>
                                                <td >
                                                    <label className="d-block text-secondary fs-sm mb-1">Plan</label>
                                                    <h6 >{item?.patient?.hmo?.name ?? "---"}</h6>
                                                </td>
                                                <td >
                                                    <label className="d-block text-secondary fs-sm mb-1">Type</label>
                                                    <h6 style={{textTransform:'capitalize'}}>{item?.requestType ?? "---"}</h6>
                                                </td>
                                                <td>
                                                    <div className="text-center">
                                                        <label className="d-block text-secondary fs-sm mb-1">Status</label>
                                                        <h6 className="">
                                                            {(() => {
                                                                const deliveryStatus = item?.delivery_status;
                                                                const isOnline = item?.order_source === 'online';
                                                                const isDispensed = item?.item?.filled === 1;
                                                                // Online bookings are auto-filled at checkout, so they
                                                                // stay "Awaiting Dispense" until picked up / delivered.
                                                                if (deliveryStatus === 'delivered') {
                                                                    return <span className="bg-primary text-white px-2 py-1 badge">Delivered</span>;
                                                                }
                                                                if (deliveryStatus === 'picked_up') {
                                                                    return <span className="bg-success text-white px-2 py-1 badge">Picked Up</span>;
                                                                }
                                                                if (isDispensed && isOnline) {
                                                                    return <span className="bg-secondary text-white px-2 py-1 badge">Awaiting Dispense</span>;
                                                                }
                                                                if (isDispensed) {
                                                                    return <span className="bg-info text-white px-2 py-1 badge">Dispensed</span>;
                                                                }
                                                                return <span className="bg-warning text-white px-2 py-1 badge">Awaiting Dispense</span>;
                                                            })()}
                                                        </h6>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                   
                                </Accordion.Header>

                                <Accordion.Body className='accordion-body' >
                                    <Table className='product-wrapper table-agent mb-0' style={{ '--bs-table-bg': 'transparent', '--bs-table-color': 'transparent' }} responsive>
                                        <tbody>
                                            {item?.requests?.map(request => (
                                                <tr key={request?.id} style={{ width: '100%' }}>
                                                    {/* <td>
                                                        <div>
                                                            <label className='text-danger'>{request?.item.vaccine?.name_of_vaccine}</label>
                                                            <h6 className="d-block text-secondar fs-sm mb-1">
                                                                <span>{request?.item?.vaccine?.description}</span>,
                                                                <span>{request?.item?.vaccine?.period}</span>
                                                            </h6>
                                                        </div>
                                                    </td> */}
                                                    <td className='gap-2 '>
                                                        <div className="d-flex align-items-center gap-2">
                                                            <div className="avatar border border-2 border-success text-info d-flex justify-content-center align-items-center"><i className="ri-coin-line"></i></div>
                                                            <div>
                                                                <h6 className="mb-1 text-danger">
                                                                    {request?.item?.vaccine?.name_of_vaccine || request?.item?.drug?.name || request?.item?.drugGeneric?.name}
                                                                </h6>
                                                                <h6 className="fs-sm text-secondary">
                                                                    {/* <span>{request?.item?.drug?.batches[1]?.quantity} Tablet</span>, */}
                                                                    <span>
                                                                        {request?.item?.fill_quantity || request?.item?.drugGeneric?.form}
                                                                        {request?.item?.fill_quantity && " Tablets"}
                                                                        </span>,
                                                                    <span>
                                                                        {request?.item?.duration + " Days" || " "} 
                                                                        {/* {request?.item?.frequencyType ?? " "}  */}
                                                                    </span>,
                                                                    <span>
                                                                        {request?.item?.vaccine?.period ?? " "}
                                                                    </span>

                                                                    {/* , 3 times Daily | 4 Days */}
                                                                </h6>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td >
                                                        {/* <label className="d-block text-secondary fs-sm mb-1">Non-Refillable</label> */}
                                                        <h6>{request?.item?.refillable === false ? "Non-Refillable" : request?.item?.refillable === true? 'Refillable' : null }</h6>
                                                    </td>

                                                    <td >
                                                        <label className="d-block text-secondary fs-sm mb-1 text-capitalize">Dr.{request?.createdBy || request?.createdBy?.first_name + ' ' +request?.item?.createdBy?.last_name }</label>
                                                        <h6 >{item?.createdBy?.profession || " "}</h6>
                                                    </td>
                                                    <td >
                                                        <label className="d-block text-primary fs-sm mb-1">{moment(request?.item?.createdAt).format("D MMM, YYYY")}</label>
                                                        <h6>{moment(request?.item?.createdAt).format("dddd, h:mm A")}</h6>
                                                    </td>
                                                    <td >
                                                        <label className="d-block text-secondary fs-sm mb-1">{request?.item?.transaction?.amount_paid ? <span>₦{request?.item?.transaction?.amount_paid.toLocaleString()}</span> :'---'}</label>
                                                        <h6>{request?.item?.transaction?.payment_method}</h6>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                               

                                </Accordion.Body>
                            </Accordion.Item>
                        )
                    })}
                    {
                        !loading && (
                            <div className="data-pagination">
                                <Button
                                variant="light"
                                disabled={currentPage === 1}
                                onClick={() => setCurrentPage(currentPage - 1)}
                                >
                                Previous
                                </Button>
                                <span>Page {currentPage} of {totalPages}</span>
                                <Button
                                variant="light"
                                disabled={currentPage === totalPages}
                                onClick={() => setCurrentPage(currentPage + 1)}
                                >
                                Next
                                </Button>
                            </div>
                        )
                    }
                </Accordion>
            )}
        </>
    )
}

export default DrugsAndPrescription;
